import { Injectable, signal } from '@angular/core';
import { SEOService } from '../../../../core/services/seo.service';
import { ILandingPost } from '../interface';
import { LandingPostService } from './landing-post.service';

@Injectable()
export class LandingPageDataService {
  readonly landingId = signal<string>('');
  readonly isQrCode = signal<boolean>(false);
  readonly isLiked = signal<boolean>(false);
  visitorId = signal<string | undefined>(undefined);
  isLoaded = signal(false);

  readonly details = signal<ILandingPost>({} as any);

  constructor(
    private landingPostService: LandingPostService,
    private seoService: SEOService,
  ) {}
}
